import React, { useContext, useEffect, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Img,
  Box,
  HStack,
  Text,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Input,
  Heading,
  Stack,
  useDisclosure,
  Center,
  Wrap,
} from "@chakra-ui/react";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavMenu,
  MobileIcon,
} from "./NavBar.elements";
import StyledNavLinks from "./StyledNavLinks";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useLang } from "../../hooks/lang-hook";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

function MainNavigation({ }) {
  //on handleKeyDown
  const logo =
    "https://res.cloudinary.com/wow-importer/image/upload/v1664462670/my-portfolio/logo_ggwato.svg";

  const { isOpen, onOpen, onClose } = useDisclosure();
  const keyPress = (event) => {
    if (event?.key === "Enter") {
      navigate("/all-products", { state: "" });
      // setSearchValue("");
    }
  };
  const [isSmallerThan350] = useMediaQuery("(max-width: 350px)");

  const navigate = useNavigate();
  const { changeLang, isOro, isAmh } = useLang();

  const [isSmallerThan768] = useMediaQuery("(max-width: 768px)");

  const location = useLocation();

  const adminMode = location?.pathname.startsWith("/administration");
  const btnRef = React.useRef();

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Nav
        transparentBg={
          (location?.pathname.toLowerCase() === "/about" ||
            location?.pathname.toLowerCase() === "/about/") &&
            scrollPosition < 100 &&
            !isSmallerThan768
            ? true
            : false
        }
        adminMode={adminMode}
      >
        <Wrap
          // bg="red"
          maxW="7xl"
          mx="auto"
          w="100%"
          justify={"space-between"}
          px={{
            base: "4%",
            sm: "5%",
            md: "5%",
            lg: "6%",
            xl: "6%",
            "2xl": "7%",
          }}
        >
          <NavLogo to="/">
            <HStack spacing={{ base: "-2px", sm: "2px" }}>
              <Img h="1.7rem" src={logo} />
            </HStack>
          </NavLogo>
          {isSmallerThan768 ? (
            <Box cursor={"pointer"} onClick={onOpen}>
              <GiHamburgerMenu color="#d7e7f2" size={30} />
            </Box>
          ) : (
            <NavMenu>
              <StyledNavLinks />
            </NavMenu>
          )}
        </Wrap>{" "}
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent bg="#000000">
            <Box w="100%" mt="10px">
              <Box py="2%" px="9%">
                <Link to="/">
                  <HStack>
                    <Img h="1.7rem" src={logo} />
                  </HStack>
                </Link>
              </Box>
            </Box>
            <StyledNavLinks onClose={onClose} click={isOpen} />
          </DrawerContent>
        </Drawer>
      </Nav>{" "}
    </>
  );
}

export default MainNavigation;
